import { createInventoryTransaction } from "../../api/inventoryService";

export const useCreateInventoryTransaction = (successCallback) => {
    const create = async (data) => {
        try {
            const newRecord = await createInventoryTransaction(data);
            if (successCallback)
            {
                successCallback(newRecord);
            }
            return newRecord;
        } catch (error) {
            console.error("Failed to create inventory transaction:", error);
            throw error; // rethrow so the component can handle errors
        }
    };

  return { create };
};